import React, { useEffect, useRef } from 'react';
import "./Accueil.css";

const Accueil = () => {
    const bgRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (e) => {
            const { clientX, clientY } = e;
            const moveX = clientX / window.innerWidth * 30;
            const moveY = clientY / window.innerHeight * 30;
            if (bgRef.current) {
                bgRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
            }
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <section className='accueil'>
            <div className='hero-background' ref={bgRef}>
                <div className='gradient-sphere'></div>
                <div className='gradient-sphere-2'></div>
                <div className='grid-lines'></div>
            </div>

            <div className='content-wrapper'>
                <h1 className='main-title'>
                    Ingénieur Logiciel <br />
                    <span className='text-gradient'>Full Stack & DevOps</span>
                </h1>

                <p className='description'>
                    Ingénieur logiciel senior spécialisé en développement Full-Stack et en architecture logicielle, je conçois des applications web et mobiles robustes, sécurisées et évolutives. J’allie expertise technique, rigueur architecturale et vision produit
                    pour transformer des besoins métier en solutions fiables, maintenables et performantes.
                </p>

                <div className='cta-group'>
                    <a href="#projects" className='btn-primary'>
                        <span>Voir mes travaux</span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    </a>
                    <a href="#cv" className='btn-secondary'>Télécharger CV</a>
                </div>
            </div>

            <div className='scroll-indicator'>
                <span className='scroll-text'>SCROLL</span>
                <div className='mouse'>
                    <div className='wheel'></div>
                </div>
            </div>
        </section>
    );
}

export default Accueil;